import script from "./EditCarPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCarPage.vue?vue&type=script&setup=true&lang=js"

import "./EditCarPage.vue?vue&type=style&index=0&id=460422f7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460422f7"]])

export default __exports__